/* global event, form_id, current_page */
var $ = window.jQuery;
var SELECTOR = '#gpvue-questionnaire';

var container = null;
var intro = null;
var beginSurvey = null;
var survey = null;
var submit = null;
var bubs = null;
var pages = null;
var pageNumber = null;
var progressBar = null;
var formNav = null;
var gf_active_page = 0;
var nexties = null;
var previes = null;

function onDocumentReady() {
	container = $(SELECTOR);

	if (container.length > 0) {
		intro = $('.intro', container);
		beginSurvey = $('.cta.begin-survey', container);
		survey = $('.survey', container);
		submit = $('.cta.complete-survey', container);
		bubs = $('.mr-bubs', container);
		pageNumber = $('.progress-bar .current', container);
		pages = $('.gform_page');
		progressBar = $('.progress-bar', container);
		formNav = $('.form-nav', container);
		nexties = $('.gform_next_button', container);
		previes = $('.gform_previous_button', container);

		startSurvey();
	}

	if ($('.quick-start').length > 0) {
		onClickBeginSurvey();
	}
}

function startSurvey() {
	beginSurvey.on('click', onClickBeginSurvey);

	$(document).on('gform_page_loaded', function (event, form_id, current_page) {
		updateProgress(form_id, current_page);
	});

	$(document).on('gform_confirmation_loaded', function (event, form_id, current_page) {
		progressBar.hide();
	});
}

function onClickBeginSurvey() {
	let id = $('.form-wrapper').data('id');

	intro.slideUp();
	survey.slideDown(400);
	$(`#gform_page_${id}_1`).slideDown();
}

function getPageNumber(button) {
	let pageId = $(button).parents('.gform_page').attr('id'),
		pageArray = pageId.split("_"),
		pageNumber = pageArray[pageArray.length - 1];

	if (pageNumber) {
		return pageNumber;
	} else {
		console.log('getCurrentPage function broke');
	}
}

function updateProgress(form, pageID) {
	let progress = pageID / parseInt(progressBar.find('.total').text());

	bubs.find('.fill').css('transform', `scaleX(${progress})`);
	pageNumber.text(pageID);

	$(`#gform_page_${form}_${pageID}`).slideDown();
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
